import React from 'react';
import PropTypes from 'prop-types';

export default function LocationLocationFoundBlock(props) {

  const classes = ['dc-location-found-block'];

  if (props.orientation === 'horizontal') {
    classes.push('dc-location-found-block__horizontal');
  } else {
    classes.push('dc-location-found-block__vertical');
  }

  return (
    <div className={classes.join(' ')}>
      <span className="dc-location-found-block__label">
        {props.locationFoundLabel}
      </span>
      <span className="dc-location-found-block__location-name">
        {` ${props.locationName} `}
      </span>
      <a
        className="dc-link"
        href="#change-location"
        onClick={props.onLinkClick}
      >
        {props.linkLabel}
      </a>
    </div>
  );
}

LocationLocationFoundBlock.propTypes = {
  locationFoundLabel: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func.isRequired,
  orientation: PropTypes.oneOf([
    'horizontal',
    'vertical'
  ])
};

LocationLocationFoundBlock.defaultProps = {
  orientation: 'horizontal'
};
